export interface BuildWhatsAppClickToChatUrlParams {
  phone: string;
  message?: string;
}

export const normalizeWhatsAppPhoneNumber = (phone: string): string =>
  phone.replace(/\D/g, '');

export const buildWhatsAppClickToChatUrl = ({
  phone,
  message,
}: BuildWhatsAppClickToChatUrlParams): string => {
  const phoneDigits = normalizeWhatsAppPhoneNumber(phone);
  const text = message ? `?text=${encodeURIComponent(message)}` : '';

  return `https://wa.me/${phoneDigits}${text}`;
};
